import styled from "styled-components";

import { Button } from "@ebscois/react-component-library";

export const StyledPdfLink = styled(Button)`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  font-size: ${({ theme }) => theme.font.size.md};
  padding-left: ${({ theme }) => theme.space.sm};

  &:not(:last-child):after {
    content: "";
    width: 1px;
    height: ${({ theme }) => theme.space.md};
    margin-left: ${({ theme }) => theme.space.sm};
    background: ${({ theme }) => theme.colors.gray700};
  }
`;
